<template>
  <b-card class="pb-2">
    <!-- about -->

    <div
      class="d-flex justify-content-start align-items-center mb-1"
    >
      <!-- avatar -->
      <b-avatar
        src=""
        size="50"
        class="mr-1"
      />
      <!--/ avatar -->
      <div class="profile-user-info">
        <h6 class="mb-0">
          {{ user.full_name }}
        </h6>
        <b-badge
          class="px-1"
          :variant="statusVariant(user.role.name)"
        >
          {{ user.role.name }}
        </b-badge>
      </div>
    </div>

    <hr>

    <!--    <div
      v-for="(data,key,index) in aboutData"
      :key="data.title"
      :class="index ? 'mt-2':''"
    >-->
    <div>
      <div v-if="user.role_id != 6">
        <h5 class="mt-2 text-capitalize">
          Documento
        </h5>
        <b-card-text>
          {{ user.document_type + ': ' + user.document_number }}
        </b-card-text>
      </div>

      <div v-if="user.role_id == 5">
        <h5 class="mt-2 text-capitalize">
          ReTHUS
        </h5>
        <b-card-text>
          {{ user.rethus }}
        </b-card-text>
      </div>

      <h5 class="mt-2 text-capitalize">
        Correo electrónico
      </h5>
      <b-card-text>
        {{ user.email }}
      </b-card-text>

      <h5 class="mt-2 text-capitalize">
        Celular
      </h5>
      <b-card-text>
        {{ user.phone }}
      </b-card-text>

      <h5 class="mt-2 text-capitalize">
        Fecha de creación
      </h5>
      <b-card-text>
        {{ user.created_at }}
      </b-card-text>
    </div>

    <!--  Patient data  -->
    <div v-if="user.role_id == 7">
      <hr>
      <h5 class="mt-2 text-capitalize">
        Fecha de nacimiento
      </h5>
      <b-card-text>
        {{ user.birth_date }}
      </b-card-text>
    </div>

    <!--  Clinic data  -->
    <div v-if="user.clinic_detail">
      <hr>
      <h5 class="mt-2 text-capitalize">
        Documento
      </h5>
      <b-card-text>
        {{ user.clinic_detail.document_type + ': ' + user.clinic_detail.document_number }}
      </b-card-text>

      <h5 class="mt-2 text-capitalize">
        WhatsApp
      </h5>
      <b-card-text>
        {{ user.clinic_detail.whatsapp }}
      </b-card-text>

      <h5 class="mt-2 text-capitalize">
        Dirección
      </h5>
      <b-card-text>
        {{ user.clinic_detail.address }}
      </b-card-text>

      <h5 class="mt-2 text-capitalize">
        Ubicación
      </h5>
      <b-card-text>
        {{ user.clinic_detail.city.name + ', ' + user.clinic_detail.department.name }}
      </b-card-text>

      <h5 class="mt-2 text-capitalize">
        Redes
      </h5>
      <b-card-text>
        <b-link
          :href="user.clinic_detail.facebook"
          target="_blank"
        >
          {{ user.clinic_detail.facebook }}
        </b-link>
      </b-card-text>

      <b-card-text>
        <b-link
          :href="user.clinic_detail.instagram"
          target="_blank"
        >
          {{ user.clinic_detail.instagram }}
        </b-link>
      </b-card-text>

      <b-card-text>
        <b-link
          :href="user.clinic_detail.youtube"
          target="_blank"
        >
          {{ user.clinic_detail.youtube }}
        </b-link>
      </b-card-text>

      <b-card-text>
        <b-link
          :href="user.clinic_detail.linkedin"
          target="_blank"
        >
          {{ user.clinic_detail.linkedin }}
        </b-link>
      </b-card-text>
    </div>
  </b-card>
</template>

<script>
import {
  BAvatar, BBadge, BCard, BCardText, BLink,
} from 'bootstrap-vue'

export default {
  components: {
    BBadge,
    BAvatar,
    BCard,
    BCardText,
    BLink,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Admin: 'light-primary',
        Comercial: 'light-success',
        Planificador: 'light-danger',
        Técnico: 'light-warning',
        Odontólogo: 'light-info',
        Clínica: 'light-secondary',
        Paciente: 'light-danger',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
  },
}
</script>
